module.exports = __webpack_public_path__ + "static/media/kdb-banner-3.130b4c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdb-banner-3.png
// module id = 1277
// module chunks = 1